export const SCRIPT_ELEMENT_ID = "au-cweb-script"
